
console.log("Travel Submit JS Loaded");
/* =====================================================
   ZAAN TRAVELS - TRAVEL STORY SUBMISSION
   PART 1
===================================================== */

/* -----------------------------
   SUPABASE CONFIG
------------------------------ */

const SUPABASE_URL = "https://pvrirhztzubkaxhsmdwu.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB2cmlyaHp0enVia2F4aHNtZHd1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI4OTI3NTMsImV4cCI6MjA5ODQ2ODc1M30.qyohYZikuKiEV1B3dKW3evyvTvcLCE3OWN9jpaGzHSA";

/* -----------------------------
   CREATE CLIENT
------------------------------ */

const supabaseClient = window.supabase.createClient(
    SUPABASE_URL,
    SUPABASE_ANON_KEY
);
/* -----------------------------
   DOM ELEMENTS
------------------------------ */

const form = document.getElementById("travelStoryForm");
const preview = document.getElementById("imagePreview");
const imageInput = document.getElementById("story_images");
const message = document.getElementById("travelMessage");
const submitButton = document.querySelector(".travel-submit-btn");

/* -----------------------------
   IMAGE PREVIEW
------------------------------ */

imageInput.addEventListener("change", function () {

  preview.innerHTML = "";

  const files = [...this.files];

  files.forEach(file => {

    if (!file.type.startsWith("image/")) return;

    const reader = new FileReader();

    reader.onload = function (e) {

      const img = document.createElement("img");

      img.src = e.target.result;

      img.loading = "lazy";

      preview.appendChild(img);

    };

    reader.readAsDataURL(file);

  });

});

/* -----------------------------
   MESSAGE FUNCTION
------------------------------ */

function showMessage(text, type) {

  message.className = "travel-message " + type;

  message.innerHTML = text;

  message.style.display = "block";

}

/* -----------------------------
   HIDE MESSAGE
------------------------------ */

function hideMessage() {

  message.style.display = "none";

  message.innerHTML = "";

}

/* -----------------------------
   BUTTON LOADING
------------------------------ */

function setLoading(status) {

  submitButton.disabled = status;

  if (status) {

    submitButton.innerHTML = "Submitting...";

  } else {

    submitButton.innerHTML = "Submit Travel Story";

  }

}

/* -----------------------------
   RESET FORM
------------------------------ */

function resetForm() {

  form.reset();

  preview.innerHTML = "";

}

/* -----------------------------
   GET FORM DATA
------------------------------ */

function getFormData() {

  return {

    name: document.getElementById("traveller_name").value.trim(),

    email: document.getElementById("traveller_email").value.trim(),

    destination: document.getElementById("destination").value.trim(),

    title: document.getElementById("story_title").value.trim(),

    travel_date: document.getElementById("travel_date").value,

    story: document.getElementById("story_content").value.trim(),

    rating: parseInt(document.getElementById("story_rating").value)

  };

}
/* =====================================================
   ZAAN TRAVELS - PART 2
   VALIDATION + IMAGE UPLOAD
===================================================== */

/* -----------------------------
   VALIDATE FORM
------------------------------ */

function validateForm(data) {

    if (!data.name) {
        showMessage("Please enter your full name.", "error");
        return false;
    }

    if (!data.email) {
        showMessage("Please enter your email.", "error");
        return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(data.email)) {
        showMessage("Please enter a valid email address.", "error");
        return false;
    }

    if (!data.destination) {
        showMessage("Please enter your destination.", "error");
        return false;
    }

    if (!data.title) {
        showMessage("Please enter a travel title.", "error");
        return false;
    }

    if (!data.story) {
        showMessage("Please write your travel story.", "error");
        return false;
    }

    if (imageInput.files.length === 0) {
        showMessage("Please upload at least one image.", "error");
        return false;
    }

    return true;
}

/* -----------------------------
   UPLOAD IMAGES
------------------------------ */

async function uploadImages() {

    const files = [...imageInput.files];

    const uploadedImages = [];

    for (const file of files) {

        const extension = file.name.split(".").pop();

        const uniqueName =
            Date.now() +
            "-" +
            Math.random().toString(36).substring(2, 10) +
            "." +
            extension;

        const filePath = "stories/" + uniqueName;

        const { error } = await supabaseClient.storage
            .from("travel-images")
            .upload(filePath, file);

        if (error) {
            throw error;
        }

        const { data } = supabaseClient.storage
            .from("travel-images")
            .getPublicUrl(filePath);

        uploadedImages.push(data.publicUrl);

    }

    return uploadedImages;

}

/* -----------------------------
   SAVE STORY
------------------------------ */

async function saveStory(formData, imageUrls) {

   const { error } = await supabaseClient
    .from("travel_stories")
        .insert([
            {
                name: formData.name,
                email: formData.email,
                destination: formData.destination,
                title: formData.title,
                travel_date: formData.travel_date || null,
                story: formData.story,
                rating: formData.rating,
                images: imageUrls,
                approved: false
            }
        ]);

    if (error) {
        throw error;
    }

}
/* =====================================================
   ZAAN TRAVELS - PART 3
   FORM SUBMISSION
===================================================== */

form.addEventListener("submit", async function (e) {

    e.preventDefault();

    hideMessage();

    const formData = getFormData();

    if (!validateForm(formData)) {
        return;
    }

    try {

        setLoading(true);

        // Upload Images
        const imageUrls = await uploadImages();

        // Save Story
        await saveStory(formData, imageUrls);

        // Success
        showMessage(
            "🎉 Thank you! Your travel story has been submitted successfully. Our team will review it before publishing.",
            "success"
        );

        resetForm();

    } catch (error) {

        console.error(error);

        showMessage(
            error.message || "Something went wrong. Please try again.",
            "error"
        );

    } finally {

        setLoading(false);

    }

});

/* =====================================================
   END OF FILE
===================================================== */